import React, { Component } from 'react';
import Icon from '../../Icon';

import '../styles.css';

class SidePanelHeader extends Component {
  render() {
    const { onDismiss, title } = this.props;

    return (
      <div className="SidePanel__header">
        <Icon
          className="SidePanel__close-modal"
          name="close"
          onClick={onDismiss}
        />
        <h3 className="SidePanel__header-title">{title}</h3>
      </div>
    );
  }
}

export default SidePanelHeader;
